module.exports = __webpack_public_path__ + "img/earnings.563dda44.svg";